import { ActivityHistoryEventType, SabalEventType, SabalInternalEvents, SabalOrganizationalEvents } from 'types';

import AccountAssignedToAllocation from './components/AccountAssignedToAllocation';
import AccountBlockedToAllocation from './components/AccountBlockedToAllocation';
import AccountCancelledReactivated from './components/AccountCancelledReactivated';
import AccountStipulation from './components/AccountStipulation';
import AccountTrancheUpdate from './components/AccountTrancheUpdate';
import AccountUnassignedFromAllocation from './components/AccountUnassignedFromAllocation';
import ActivationPackageResubmitted from './components/ActivationPackageResubmitted';
import ActivationPackageSubmitted from './components/ActivationPackageSubmitted';
import { AllocationCompleted } from './components/AllocationCompleted';
import { AllocationCreated } from './components/AllocationCreated';
import { AllocationUpdated } from './components/AllocationUpdated';
import Attestation from './components/Attestation';
import ChangeOrderEvent from './components/ChangeOrderEvent';
import ContractCreated from './components/ContractCreated';
import ContractEnvelopeSent from './components/ContractEnvelopeSent';
import ContractSent from './components/ContractSent';
import ContractSigned from './components/ContractSigned';
import ContractSignerSigned from './components/ContractSignerSigned';
import ContractVoided from './components/ContractVoided';
import CreditDecision from './components/CreditDecision';
import CreditError from './components/CreditError';
import CreditExpired from './components/CreditExpired';
import DirectPaymentLinkGenerated from './components/DirectPaymentLinkGenerated';
import DirectPaymentLinkSent from './components/DirectPaymentLinkSent';
import DirectPayOptIn from './components/DirectPayOptIn';
import DirectPayOptOut from './components/DirectPayOptOut';
import DirectPaySupportOverride from './components/DirectPaySupportOverride';
import Email from './components/Email';
import { HardwareLookupProcessed } from './components/HardwareLookupProcessed';
import HeliosCreated from './components/HeliosCreated';
import HeliosInvite from './components/HeliosInvite';
import SabalHoldbackCreated from './components/HoldbackCreated';
import SabalHoldbackUpdated from './components/HoldbackUpdated';
import IllinoisShinesSent from './components/IllinoisShinesSent';
import IllinoisShinesSigned from './components/IllinoisShinesSigned';
import MilestonePackageSavedSubmitted from './components/MilestonePackageSavedSubmitted';
import OneTimePaymentCancelled from './components/OneTimePaymentCancelled';
import OneTimePaymentScheduled from './components/OneTimePaymentScheduled';
import OperationAtCalculated from './components/OperationAtCalculated';
import OrganizationStatusChanged from './components/OrganizationStatusChanged';
import PlacedInServiceCalculated from './components/PlacedInServiceCalculated';
import PreBillingCustomerAdjustmentAccepted from './components/PreBillingCustomerAdjustmentAccepted';
import PreBillingCustomerAdjustmentApplied from './components/PreBillingCustomerAdjustmentApplied';
import PreBillingCustomerAdjustmentExpired from './components/PreBillingCustomerAdjustmentExpired';
import PreBillingCustomerAdjustmentOfferSent from './components/PreBillingCustomerAdjustmentOfferSent';
import PreBillingCustomerAdjustmentReinstated from './components/PreBillingCustomerAdjustmentReinstated';
import PreBillingCustomerAdjustmentVoided from './components/PreBillingCustomerAdjustmentVoided';
import SabalPriceSheetCreated from './components/PriceSheetCreated';
import SabalPriceSheetsMappingsArchived from './components/PriceSheetMappingsArchived';
import SabalPriceSheetsMappingsCreated from './components/PriceSheetsMappingsCreated';
import SabalPriceSheetUpdated from './components/PriceSheetUpdated';
import SabalPricingSettingCreated from './components/PricingSettingCreated';
import SabalPricingSettingUpdated from './components/PricingSettingUpdated';
import QuoteCreated from './components/QuoteCreated';
import QuoteVoided from './components/QuoteVoided';
import ReqNoLongerMetAfterVerificationDaysExpired from './components/ReqNoLongerMetAfterVerificationDaysExpired';
import SabalAccountCreated from './components/SabalAccountCreated';
import SabalAccountMilestoneUpdated from './components/SabalAccountMilestoneUpdated';
import SabalAccountUpdated from './components/SabalAccountUpdated';
import SabalAddersUpdated from './components/SabalAddersUpdated';
import SabalDispatchAssigned from './components/SabalDispatchAssigned';
import SabalDocumentApproved from './components/SabalDocumentApproved';
import SabalDocumentArchived from './components/SabalDocumentArchived';
import SabalDocumentMoved from './components/SabalDocumentMoved';
import SabalDocumentRejected from './components/SabalDocumentRejected';
import SabalDocumentSubmittedOrResubmitted from './components/SabalDocumentSubmittedOrResubmitted';
import SabalDocumentUploaded from './components/SabalDocumentUploaded';
import SabalDomesticContentEligibilityStatus from './components/SabalDomesticContentEligibilityStatus';
import SabalLeadAccepted from './components/SabalLeadAccepted';
import SabalLeadRejected from './components/SabalLeadRejected';
import SabalOrganizationCreated from './components/SabalOrganizationCreated';
import SabalOrganizationDirectPayUpdated from './components/SabalOrganizationDirectPayUpdated';
import SabalOrganizationLicensesUpdated from './components/SabalOrganizationLicensesUpdated';
import SabalOrganizationPaymentHoldChanged from './components/SabalOrganizationPaymentHoldChanged';
import SabalOrganizationReviewSlaSettingsUpdated from './components/SabalOrganizationReviewSlaSettingsUpdated';
import SabalOrganizationUnderwritingSettingsDeleted from './components/SabalOrganizationUnderwritingSettingsDeleted';
import SabalOrganizationUnderwritingSettingsUpdated from './components/SabalOrganizationUnderwritingSettingsUpdated';
import SabalPaymentFailed from './components/SabalPaymentFailed';
import SabalPaymentMethodAdded from './components/SabalPaymentMethodAdded';
import SabalSystemDesignUpdated from './components/SabalSystemDesignUpdated';
import SabalTrancheClosed from './components/SabalTrancheClosed';
import SabalUserCreated from './components/SabalUserCreated';
import SabalUserDeleted from './components/SabalUserDeleted';
import SabalUserPermissionsUpdated from './components/SabalUserPermissionsUpdated';
import SabalWarrantyPricingSettingArchived from './components/SabalWarrantyPricingSettingArchived';
import SabalWarrantyPricingSettingCreated from './components/SabalWarrantyPricingSettingCreated';
import SafeHarborBadgeUpdated from './components/SafeHarborBadgeUpdated';
import SalesRepStatusChanged from './components/SalesRepStatusChanged';
import SalesRepVerified from './components/SalesRepVerified';
import SolarFlareEmailNotificationSent from './components/SolarFlareEmailSent';
import SolarFlareSmsNotificationSent from './components/SolarFlareSmsSent';
import Unknown from './components/Unknown';
import UtilityBillExtractionProcessed from './components/UtilityBillExtractionProcessed';
import VerificationDaysCalculated from './components/VerificationDaysCalculated';
import WelcomeCallDecision, { WelcomeCallRecheckResult } from './components/WelcomeCallDecision';

export const getActivityHistoryComponent = (events: Array<any>, isPalmettoFinanceUser = false) => {
  return events
    .map((event) => {
      switch (event.eventType) {
        case ActivityHistoryEventType.sabalDocumentsArchived:
          return {
            component: SabalDocumentArchived,
            icon: 'box',
            event,
          };
        case ActivityHistoryEventType.sabalDocumentsUploaded:
          return {
            component: SabalDocumentUploaded,
            icon: 'upload',
            event,
          };
        case ActivityHistoryEventType.sabalDocumentsRejected:
          return {
            component: SabalDocumentRejected,
            icon: 'remove',
            iconColor: 'danger',
            event,
          };
        case ActivityHistoryEventType.sabalDocumentsApproved:
          return {
            component: SabalDocumentApproved,
            icon: 'check',
            iconColor: 'success',
            event,
          };
        case ActivityHistoryEventType.sabalDocumentsMoved:
          return {
            component: SabalDocumentMoved,
            icon: 'document',
            event,
          };
        case ActivityHistoryEventType.sabalDocumentsSubmitted:
        case ActivityHistoryEventType.sabalDocumentsReSubmitted:
          return {
            component: SabalDocumentSubmittedOrResubmitted,
            icon: 'note',
            event,
          };
        case ActivityHistoryEventType.sabalAddersUpdated:
          return {
            component: SabalAddersUpdated,
            icon: 'pencil',
            event,
          };
        case ActivityHistoryEventType.sabalSystemDesignCreated:
          return {
            component: SabalSystemDesignUpdated,
            icon: 'pencil',
            event,
          };
        case ActivityHistoryEventType.sabalAccountCreated:
          return {
            component: SabalAccountCreated,
            icon: 'add',
            event,
          };
        case ActivityHistoryEventType.sabalAccountUpdated:
          return {
            component: SabalAccountUpdated,
            icon: 'pencil',
            event,
          };
        case ActivityHistoryEventType.heliosUserInvited:
          return {
            component: HeliosInvite,
            icon: 'mail',
            event,
          };
        case ActivityHistoryEventType.heliosUserCreated:
          return {
            component: HeliosCreated,
            icon: 'sun',
            event,
          };
        case ActivityHistoryEventType.contractSent:
          return {
            component: ContractSent,
            icon: 'document',
            event,
          };
        case ActivityHistoryEventType.contractSigned:
          return {
            component: ContractSigned,
            icon: 'document',
            event,
          };
        case ActivityHistoryEventType.contractEnvelopeSent:
          return {
            component: ContractEnvelopeSent,
            icon: 'document',
            event,
          };
        case ActivityHistoryEventType.contractSignerSigned:
          return {
            component: ContractSignerSigned,
            icon: 'document',
            event,
          };
        case ActivityHistoryEventType.contractVoided:
          return {
            component: ContractVoided,
            icon: 'document',
            event,
          };
        case ActivityHistoryEventType.contractCreated:
          return {
            component: ContractCreated,
            icon: 'document',
            event,
          };
        case ActivityHistoryEventType.emailNotificationSent:
          return {
            component: Email,
            icon: 'mail',
            event,
          };
        case ActivityHistoryEventType.illinoisDisclosureSent:
          return {
            component: IllinoisShinesSent,
            icon: 'document',
            event,
          };
        case ActivityHistoryEventType.illinoisDisclosureSigned:
          return {
            component: IllinoisShinesSigned,
            icon: 'document',
            event,
          };
        case ActivityHistoryEventType.solarFlareEmailNotificationSent:
          return {
            component: SolarFlareEmailNotificationSent,
            icon: 'mail',
            event,
          };
        case ActivityHistoryEventType.solarFlareSmsNotificationSent:
          return {
            component: SolarFlareSmsNotificationSent,
            icon: 'chat',
            event,
          };
        case ActivityHistoryEventType.sabalQuoteCreated:
          return {
            component: QuoteCreated,
            icon: 'note',
            event,
          };
        case ActivityHistoryEventType.sabalQuoteVoided:
          return {
            component: QuoteVoided,
            icon: 'note',
            event,
          };
        case ActivityHistoryEventType.sabalPaymentMethodAdded:
          return {
            component: SabalPaymentMethodAdded,
            icon: 'add',
            event,
          };
        case ActivityHistoryEventType.sabalPaymentFailed:
          return {
            component: SabalPaymentFailed,
            icon: 'remove',
            iconColor: 'danger',
            event,
          };
        case ActivityHistoryEventType.sabalAccountMilestoneUpdated:
          return {
            component: SabalAccountMilestoneUpdated,
            icon: 'note',
            event,
          };
        case ActivityHistoryEventType.sabalCreditDecisionCompleted:
          return {
            component: CreditDecision,
            icon: 'search',
            event,
          };
        case ActivityHistoryEventType.sabalCreditDecisionError:
          return {
            component: CreditError,
            icon: 'remove',
            iconColor: 'danger',
            event,
          };
        case ActivityHistoryEventType.sabalCreditDecisionExpired:
          return {
            component: CreditExpired,
            icon: 'remove',
            iconColor: 'danger',
            event,
          };
        case ActivityHistoryEventType.sabalDesignStipulationFlagged:
          return {
            component: AccountStipulation,
            icon: 'remove',
            iconColor: 'danger',
            event,
          };
        case ActivityHistoryEventType.sabalDesignStipulationCleared:
          return {
            component: AccountStipulation,
            icon: 'check',
            iconColor: 'success',
            event,
          };
        case ActivityHistoryEventType.sabalAccountCancelled:
          return {
            component: AccountCancelledReactivated,
            icon: 'c-remove',
            event,
          };
        case ActivityHistoryEventType.sabalAccountReactivated:
          return {
            component: AccountCancelledReactivated,
            icon: 'refresh',
            event,
          };
        case ActivityHistoryEventType.sabalSalesRepUpdated:
          return {
            component: SalesRepStatusChanged,
            icon: 'user',
            event,
          };
        case ActivityHistoryEventType.sabalSalesRepVerified:
          return {
            component: SalesRepVerified,
            icon: 'check',
            event,
          };
        case ActivityHistoryEventType.sabalSystemDesignAttested:
          return {
            component: Attestation,
            icon: 'note',
            event,
          };
        case ActivityHistoryEventType.sabalNTPPackageSaved:
        case ActivityHistoryEventType.sabalNTPPackageResubmitted:
        case ActivityHistoryEventType.sabalNTPPackageSubmitted:
        case ActivityHistoryEventType.sabalInstallPackageSaved:
        case ActivityHistoryEventType.sabalInstallPackageResubmitted:
        case ActivityHistoryEventType.sabalInstallPackageSubmitted:
        case ActivityHistoryEventType.sabalLoopFieldPackageSaved:
        case ActivityHistoryEventType.sabalPermissionToOperateSubmitted:
        case ActivityHistoryEventType.sabalPermissionToOperateCompleted:
        case ActivityHistoryEventType.sabalElectricianSignOffSubmitted:
        case ActivityHistoryEventType.sabalElectricianSignOffCompleted:
          return {
            component: MilestonePackageSavedSubmitted,
            icon: 'note',
            event,
          };
        case SabalEventType.sabalHoldbackCreated:
          return {
            component: SabalHoldbackCreated,
            icon: 'note',
            event,
          };
        case SabalEventType.sabalHoldbackUpdated:
          return {
            component: SabalHoldbackUpdated,
            icon: 'note',
            event,
          };
        case SabalEventType.sabalModifierCreated:
          return {
            component: SabalPricingSettingCreated,
            icon: 'note',
            event,
          };
        case SabalEventType.sabalModifierUpdated:
          return {
            component: SabalPricingSettingUpdated,
            icon: 'note',
            event,
          };
        case SabalEventType.sabalConstructionAdderCreated:
          return {
            component: SabalPricingSettingCreated,
            icon: 'note',
            event,
          };
        case SabalEventType.sabalConstructionAdderUpdated:
          return {
            component: SabalPricingSettingUpdated,
            icon: 'note',
            event,
          };
        case SabalEventType.sabalPriceSheetsMappingsCreated:
          return {
            component: SabalPriceSheetsMappingsCreated,
            icon: 'note',
            event,
          };
        case SabalEventType.sabalPriceSheetsMappingsArchived:
          return {
            component: SabalPriceSheetsMappingsArchived,
            icon: 'note',
            event,
          };
        case SabalEventType.sabalPriceSheetCreated:
          return {
            component: SabalPriceSheetCreated,
            icon: 'note',
            event,
          };
        case SabalEventType.sabalPriceSheetUpdated:
          return {
            component: SabalPriceSheetUpdated,
            icon: 'note',
            event,
          };
        case ActivityHistoryEventType.sabalActivationPackageSubmitted:
          return {
            component: ActivationPackageSubmitted,
            icon: 'note',
            event,
          };
        case ActivityHistoryEventType.sabalActivationPackageResubmitted:
          return {
            component: ActivationPackageResubmitted,
            icon: 'note',
            event,
          };
        case ActivityHistoryEventType.sabalDomesticContentEligibilityStatusConfirmed:
        case ActivityHistoryEventType.sabalDomesticContentEligibilityStatusEpcOptOut:
        case ActivityHistoryEventType.sabalDomesticContentEligibilityStatusUnderConsideration:
          return {
            component: SabalDomesticContentEligibilityStatus,
            icon: 'note',
            event,
          };
        case ActivityHistoryEventType.sabalDirectPayOptIn:
          return {
            component: DirectPayOptIn,
            icon: 'note',
            event,
          };
        case ActivityHistoryEventType.sabalDirectPayOptOut:
          return {
            component: DirectPayOptOut,
            icon: 'note',
            event,
          };
        case ActivityHistoryEventType.sabalAccountUpdatedITCAdderQualifications:
          if (isPalmettoFinanceUser) {
            return {
              component: SabalAccountUpdated,
              icon: 'pencil',
              event,
            };
          }
          break;
        case ActivityHistoryEventType.sabalSafeHarborBadgeStatusUpdated:
          return {
            component: SafeHarborBadgeUpdated,
            icon: 'list',
            event,
          };
        case ActivityHistoryEventType.sabalLeadAccepted:
          if (isPalmettoFinanceUser) {
            return {
              component: SabalLeadAccepted,
              icon: 'check',
              iconColor: 'success',
              event,
            };
          }
          break;
        case ActivityHistoryEventType.sabalLeadRejected:
          if (isPalmettoFinanceUser) {
            return {
              component: SabalLeadRejected,
              icon: 'remove',
              iconColor: 'danger',
              event,
            };
          }
          break;
        case SabalInternalEvents.dispatchAcceptedByOrganization:
          if (isPalmettoFinanceUser) {
            return {
              component: SabalDispatchAssigned,
              icon: 'check',
              iconColor: 'success',
              event,
            };
          }
          break;
        case SabalOrganizationalEvents.sabalOrganizationDirectPayUpdated:
          return {
            component: SabalOrganizationDirectPayUpdated,
            icon: 'note',
            event,
          };
        case SabalOrganizationalEvents.sabalOrganizationLicensesUpdated:
          return {
            component: SabalOrganizationLicensesUpdated,
            icon: 'note',
            event,
          };
        case SabalOrganizationalEvents.sabalOrganizationUnderwritingSettingsUpdated:
          return {
            component: SabalOrganizationUnderwritingSettingsUpdated,
            icon: 'pencil',
            event,
          };
        case SabalOrganizationalEvents.sabalOrganizationUnderwritingSettingsDeleted:
          return {
            component: SabalOrganizationUnderwritingSettingsDeleted,
            icon: 'c-remove',
            event,
          };
        case SabalOrganizationalEvents.sabalOrganizationReviewSlaSettingsUpdated:
          return {
            component: SabalOrganizationReviewSlaSettingsUpdated,
            icon: 'pencil',
            event,
          };
        case SabalOrganizationalEvents.sabalOrganizationReviewSlaSettingsDisabled:
          return {
            component: SabalOrganizationReviewSlaSettingsUpdated,
            icon: 'c-remove',
            event,
          };
        case SabalOrganizationalEvents.sabalOrganizationUserPermissionsUpdated:
          return {
            component: SabalUserPermissionsUpdated,
            icon: 'note',
            event,
          };
        case SabalOrganizationalEvents.sabalOrganizationUserCreated:
          return {
            component: SabalUserCreated,
            icon: 'note',
            event,
          };
        case SabalOrganizationalEvents.sabalOrganizationUserDeleted:
          return {
            component: SabalUserDeleted,
            icon: 'note',
            event,
          };
        case SabalOrganizationalEvents.sabalOrganizationCreated:
          return {
            component: SabalOrganizationCreated,
            icon: 'note',
            event,
          };
        case SabalOrganizationalEvents.sabalOrganizationStatusUpdated:
          return {
            component: OrganizationStatusChanged,
            icon: 'pencil',
            event,
          };
        case SabalOrganizationalEvents.sabalTrancheClosed:
          if (isPalmettoFinanceUser) {
            return {
              component: SabalTrancheClosed,
              icon: 'note',
              event,
            };
          }
          break;
        case SabalOrganizationalEvents.accountTrancheUpdate:
          if (isPalmettoFinanceUser) {
            return {
              component: AccountTrancheUpdate,
              icon: 'note',
              event,
            };
          }
          break;

        case SabalEventType.warrantyPricingCreated:
          return {
            component: SabalWarrantyPricingSettingCreated,
            icon: 'note',
            event,
          };
        case SabalEventType.warrantyPricingArchived:
          return {
            component: SabalWarrantyPricingSettingArchived,
            icon: 'note',
            event,
          };
        case ActivityHistoryEventType.sabalOperationAtCalculated:
          return {
            component: OperationAtCalculated,
            icon: 'check',
            iconColor: 'success',
            event,
          };
        case ActivityHistoryEventType.sabalVerificationDaysCalculated:
          return {
            component: VerificationDaysCalculated,
            icon: 'calendar',
            event,
          };
        case ActivityHistoryEventType.sabalVerificationDaysExpiredAndReqNoLongerMet:
          return {
            component: ReqNoLongerMetAfterVerificationDaysExpired,
            icon: 'note',
            event,
          };
        case ActivityHistoryEventType.sabalPlacedInServiceCalculated:
          return {
            component: PlacedInServiceCalculated,
            icon: 'check',
            iconColor: 'success',
            event,
          };
        case SabalInternalEvents.sabalPreBillingCustomerAdjustmentOfferSent:
          return {
            component: PreBillingCustomerAdjustmentOfferSent,
            icon: 'mail',
            event,
          };
        case SabalInternalEvents.sabalPreBillingCustomerAdjustmentApplied:
          return {
            component: PreBillingCustomerAdjustmentApplied,
            icon: 'note',
            event,
          };
        case SabalInternalEvents.sabalPreBillingCustomerAdjustmentAccepted:
          return {
            component: PreBillingCustomerAdjustmentAccepted,
            icon: 'check',
            iconColor: 'success',
            event,
          };
        case SabalInternalEvents.sabalPreBillingCustomerAdjustmentExpired:
          return {
            component: PreBillingCustomerAdjustmentExpired,
            icon: 'note',
            event,
          };
        case SabalInternalEvents.sabalPreBillingCustomerAdjustmentVoided:
          return {
            component: PreBillingCustomerAdjustmentVoided,
            icon: 'note',
            event,
          };
        case SabalInternalEvents.sabalPreBillingCustomerAdjustmentReinstated:
          return {
            component: PreBillingCustomerAdjustmentReinstated,
            icon: 'check',
            iconColor: 'success',
            event,
          };

        case SabalInternalEvents.sabalAccountsAssignedToAllocation:
          return {
            component: AccountAssignedToAllocation,
            icon: 'check',
            event,
          };
        case SabalInternalEvents.sabalAccountsUnassignedFromAllocation:
          return {
            component: AccountUnassignedFromAllocation,
            icon: 'remove',
            event,
          };
        case SabalInternalEvents.sabalAllocationBlocked:
          return {
            component: AccountBlockedToAllocation,
            icon: 'padlock',
            event,
          };
        case SabalInternalEvents.sabalAllocationCreated:
          return {
            component: AllocationCreated,
            icon: 'check',
            event,
          };
        case SabalInternalEvents.sabalAllocationUpdated:
          return {
            component: AllocationUpdated,
            icon: 'exclamation-mark',
            event,
          };
        case SabalInternalEvents.sabalAllocationCompleted:
          return {
            component: AllocationCompleted,
            icon: 'celebration',
            iconColor: 'success',
            event,
          };
        case SabalInternalEvents.sabalOneTimePaymentScheduled:
          return {
            component: OneTimePaymentScheduled,
            icon: 'note',
            event,
          };
        case SabalInternalEvents.sabalOneTimePaymentCancelled:
          return {
            component: OneTimePaymentCancelled,
            icon: 'remove',
            event,
          };
        case SabalInternalEvents.sabalUtilityBillExtractionProcessed:
          return {
            component: UtilityBillExtractionProcessed,
            icon: 'document',
            event,
          };
        case SabalInternalEvents.sabalDirectPaymentLinkCreated:
        case SabalInternalEvents.sabalDirectPaymentLinkEmailed:
        case SabalInternalEvents.sabalDirectPaymentLinkSmsed:
          return {
            component: DirectPaymentLinkSent,
            icon: 'link',
            event,
          };
        case SabalInternalEvents.sabalDirectPaymentLinkGenerated:
          return {
            component: DirectPaymentLinkGenerated,
            icon: 'link',
            event,
          };
        case SabalInternalEvents.sabalChangeOrderEmailed:
          return {
            component: ChangeOrderEvent,
            icon: 'mail',
            event,
          };
        case SabalInternalEvents.sabalChangeOrderSmsed:
          return {
            component: ChangeOrderEvent,
            icon: 'phone',
            event,
          };
        case SabalInternalEvents.sabalChangeOrderResendSent:
          return {
            component: ChangeOrderEvent,
            icon: 'mail',
            event,
          };
        case SabalInternalEvents.sabalChangeOrderViewed:
          return {
            component: ChangeOrderEvent,
            icon: 'note',
            event,
          };
        case SabalInternalEvents.sabalChangeOrderAccepted:
          return {
            component: ChangeOrderEvent,
            icon: 'check',
            iconColor: 'success',
            event,
          };
        case SabalInternalEvents.sabalChangeOrderDeclined:
          return {
            component: ChangeOrderEvent,
            icon: 'remove',
            iconColor: 'danger',
            event,
          };
        case SabalInternalEvents.sabalHardwareLookupProcessed:
          if (isPalmettoFinanceUser) {
            return {
              component: HardwareLookupProcessed,
              icon: 'list',
              event,
            };
          }
          break;
        case ActivityHistoryEventType.sabalDirectPayOverride:
          return {
            component: DirectPaySupportOverride,
            icon: 'padlock',
            event,
          };
        case SabalOrganizationalEvents.sabalOrganizationPayoutHoldUpdated:
          return {
            component: SabalOrganizationPaymentHoldChanged,
            icon: 'check',
            event,
          };
        case SabalInternalEvents.sabalChangeOrderCreated:
          return {
            component: ChangeOrderEvent,
            icon: 'add',
            event,
          };
        case SabalInternalEvents.sabalChangeOrderExecuted:
          return {
            component: ChangeOrderEvent,
            icon: 'check',
            iconColor: 'success',
            event,
          };
        case SabalInternalEvents.sabalChangeOrderCancelled:
          return {
            component: ChangeOrderEvent,
            icon: 'c-remove',
            event,
          };
        case SabalInternalEvents.sabalChangeOrderVoided:
          return {
            component: ChangeOrderEvent,
            icon: 'c-remove',
            event,
          };
        case SabalInternalEvents.sabalChangeOrderEpcNotified:
        case SabalInternalEvents.sabalChangeOrderCustomerNotified:
          return {
            component: ChangeOrderEvent,
            icon: 'mail',
            event,
          };
        case SabalInternalEvents.welcomeCallApproved:
          if (isPalmettoFinanceUser) {
            return {
              component: WelcomeCallDecision,
              icon: 'check',
              iconColor: 'success',
              event,
            };
          }
          break;
        case SabalInternalEvents.welcomeCallRejected:
          if (isPalmettoFinanceUser) {
            return {
              component: WelcomeCallDecision,
              icon: 'remove',
              iconColor: 'danger',
              event,
            };
          }
          break;
        case SabalInternalEvents.welcomeCallRecheckPassed:
          if (isPalmettoFinanceUser) {
            return {
              component: WelcomeCallRecheckResult,
              icon: 'check',
              iconColor: 'success',
              event,
            };
          }
          break;
        case SabalInternalEvents.welcomeCallRecheckFailed:
          if (isPalmettoFinanceUser) {
            return {
              component: WelcomeCallRecheckResult,
              icon: 'exclamation-mark',
              iconColor: 'danger',
              event,
            };
          }
          break;
        default:
          return !isPalmettoFinanceUser
            ? undefined
            : {
                component: Unknown,
                icon: 'question-mark',
                event,
              };
      }
    })
    .filter((event) => !!event);
};
